import React, { useEffect, useRef } from "react";
import "./styles.scss";

const DIGITS_COUNT = 4;

const LoginVerification = ({ code, setCode, failed, setFailed }) => {
  const inputRefs = useRef(new Array(DIGITS_COUNT));

  useEffect(() => {
    if (inputRefs?.current?.[0]) inputRefs.current[0].focus();
  }, [failed]);

  const handleKeyDown = (e, i) => {
    const { key, keyCode } = e;
    const newCode = code.slice();

    // Digits 0-9 
    if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
      e.preventDefault();
      newCode.splice(i, 1, key);
      if (i < DIGITS_COUNT - 1) {
        inputRefs.current[i + 1].focus();
      } else {
        inputRefs.current[i].blur();
      }
      setCode(newCode);
      if (failed) setFailed(null);
      return;
    }

    // Backspace
    if (keyCode === 8) {
      e.preventDefault();
      newCode.splice(i, 1, "");
      if (i > 0) {
        inputRefs.current[i - 1].focus();
      }
      setCode(newCode);
      if (failed) setFailed(null);
      return;
    }

    // Tab / Shift+Tab 
    if (keyCode === 9) {
      if (!e.shiftKey && i < DIGITS_COUNT - 1) {
        e.preventDefault();
        inputRefs.current[i + 1].focus();
      } else if (e.shiftKey && i > 0) {
        e.preventDefault();
        inputRefs.current[i - 1].focus();
      }
      return;
    }

    // Arrow keys 
    if (keyCode === 37 && i > 0) {
      e.preventDefault();
      inputRefs.current[i - 1].focus();
    } else if (keyCode === 39 && i < DIGITS_COUNT - 1) {
      e.preventDefault();
      inputRefs.current[i + 1].focus();
    }
  };

  const handlePaste = (e, i) => {
    e.preventDefault();
    const pasted = (e.clipboardData?.getData("text") || "").replace(/\D/g, "").slice(0, DIGITS_COUNT);
    if (!pasted) return;

    const newCode = [...code];
    pasted.split("").forEach((digit, idx) => {
      const pos = i + idx;
      if (pos < DIGITS_COUNT) newCode[pos] = digit;
    });
    setCode(newCode);
    if (failed) setFailed(null);

    const nextFocus = Math.min(i + pasted.length, DIGITS_COUNT - 1);
    inputRefs.current[nextFocus].focus();
  };

  return (
    <div className="login-verification-conatiner">
      {failed === "invalid" && <div className="row code-invalid">Кодът е грешен</div>}
      <div className="code-container">
        <div className="row code-conatiner-inner">
          {new Array(DIGITS_COUNT).fill("").map((v, i) => (
            <input
              key={`input-${i}`}
              ref={(ref) => (inputRefs.current[i] = ref)}
              className={`digit-container ${failed === true ? "invalid" : ""} ${failed === false ? "valid" : ""}`}
              type="text"
              inputMode="numeric"
              maxLength="1"
              size="1"
              min="0"
              max="9"
              pattern="[0-9]{1}"
              value={code[i] || ""}
              onChange={() => {}}
              onKeyDown={(e) => handleKeyDown(e, i)}
              onPaste={(e) => handlePaste(e, i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoginVerification;
